import { __decorate } from "tslib";
import { DataObject, rawDataSymbol, rtfm } from '@twurple/common';
/**
 * A stream tag.
 */
let HelixTag = class HelixTag extends DataObject {
    /**
     * The ID of the tag.
     */
    get id() {
        return this[rawDataSymbol].tag_id;
    }
    /**
     * Whether the tag is automatically assigned by Twitch.
     */
    get isAuto() {
        return this[rawDataSymbol].is_auto;
    }
    /**
     * Gets the name of the tag in the specified language.
     *
     * @param language The language to get the name in.
     */
    getName(language) {
        return this[rawDataSymbol].localization_names[language];
    }
    /**
     * Gets the description of the tag in the specified language.
     *
     * @param language The language to get the description in.
     */
    getDescription(language) {
        return this[rawDataSymbol].localization_descriptions[language];
    }
};
HelixTag = __decorate([
    rtfm('api', 'HelixTag', 'id')
], HelixTag);
export { HelixTag };
